abcsetup.promos = abcsetup.promos || {};
abcsetup.promos.plans = abcsetup.promos.plans || {};
abcsetup.promos.plans.vendors = abcsetup.promos.plans.vendors || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos.plans.vendors = {
    categoryFilter: [],

    init: function() {
        abcsetup.setTitle('Promotional Plans');
        $('[data-toggle="tooltip"]').tooltip();

        this.initListeners();
        // this.renderPlans();
    },
    initListeners: () => {
        $(document).on('click','.btn-categories',function() {
            axios.get('/api/promos/plans/categories?vendor=' + $(this).data('vendor') + '&fiscal_year=' + $(this).data('fiscal-year'))
                .then((response) => {
                    var tr = $(this).closest('tr');
                    var categories = response.data;
                    var html = '';
                    for( var idx in categories) {
                        if(parseInt(categories[idx].total_perc_budget) > 0)
                            html +=  '<div>' + categories[idx].category_name+ ': $' + parseInt(categories[idx].total_perc_budget) + '</div>'
                    }
                    if (!html) {
                        html = "No item categories are associated with this plan";
                    }
                    html ='<div class="promo_plan_categories">'+html+'</div>';
                    $('#category-modal').modal('show');
                    $('#category-modal').find('.modal-body').html(html);
                });
        });

        // $(document).on('click', 'th.category-filter', function() {
        //     $('#category-filter-modal').modal('show');
        // });
        // $(document).on('#category-filter-modal input', function() {
        //     abcsetup.promos.plans.vendors.categoryFilter = [];
        //     $('#category-filter-modal input').each( function() {
        //         if($(this).is(':checked'))
        //             abcsetup.promos.plans.vendors.categoryFilter.push($(this).val());
        //     });
        // });

        // $(document).on('click', '#category-filter-modal .submit-cat-filter', () => {
        //     abcsetup.promos.plans.vendors.renderPlans();
        //     $('#category-filter-modal').modal('hide');
        // });

        // $(document).on('click', '#category-filter-modal .reset-cat-filter', () => {

        //     abcsetup.promos.plans.vendors.categoryFilter = [];
        //     abcsetup.promos.plans.vendors.renderPlans();
        //     $('#category-filter-modal').modal('hide');
        // });

        // delete button clicked
        $(document).on('click', '.btn-delete-promo_plan', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Delete Promo Plan', 'Are you sure you want to delete this promo plan?', function (resp) {
                if (resp) {
                    abcsetup.promos.plans.vendors.delete(_this.data('id'));
                }
            });
        });
    },

    /**
     *
     */
    delete: function (id) {
        // abcsetup.dashboard.showLoading($('#events_panel'));
        // $('#events_panel').find('#vendor_plans table, #vendor_plans .dataTables_wrapper').hide();
        abcsetup.blockUI();
        axios.delete('/api/promos/plans/' + id).then(response => {
            location.reload();
        });
    },
}
